var map = {
	"./symbol_0.png": 75014,
	"./symbol_1.png": 43759,
	"./symbol_10.png": 13759,
	"./symbol_11.png": 35670,
	"./symbol_12.png": 26349,
	"./symbol_2.png": 21300,
	"./symbol_3.png": 58781,
	"./symbol_4.png": 49634,
	"./symbol_5.png": 13291,
	"./symbol_6.png": 47888,
	"./symbol_7.png": 63641,
	"./symbol_8.png": 48078,
	"./symbol_9.png": 21719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47825;